// Desktop product photo hover zoom: the photo magnifies 2.2x toward the spot under the cursor and follows it.
// Only for a mouse/trackpad on screens 768px+; touch and mobile keep tap-to-open. Swaps in a larger image on first hover.
const canHover = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
const SCALE = 2.2;

for (const button of document.querySelectorAll('[data-hover-zoom]')) {
  const img = button.querySelector('img');
  if (!img) continue;
  let upgradedTo = 0;
  let frame = 0;

  const move = (e) => {
    if (!canHover.matches || e.pointerType !== 'mouse') return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const r = button.getBoundingClientRect();
      const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = `scale(${SCALE})`;
    });
  };

  button.addEventListener('pointerenter', (e) => {
    if (!canHover.matches || e.pointerType !== 'mouse') return;
    // Ask for an image sharp enough for the zoomed size on this screen (e.g. ~2400px on a retina laptop).
    const needed = Math.ceil(button.getBoundingClientRect().width * SCALE);
    if (needed > upgradedTo) {
      upgradedTo = needed;
      img.loading = 'eager';
      img.decoding = 'async';
      img.sizes = `${needed}px`;
    }
    if (reduced.matches) img.style.transition = 'none';
    move(e);
  });
  button.addEventListener('pointermove', move);
  button.addEventListener('pointerleave', () => {
    cancelAnimationFrame(frame);
    img.style.transform = '';
  });
}
